module.exports = __webpack_public_path__ + "img/3.048a5ca.svg";